import { mergeLocale} from 'antd-mobile/es/utils/merge-locale'
import { base } from 'antd-mobile/es/locales/base';
const typeTemplate = '${label} ${type} sifatida qabul qilinmaydi';

const arSA = mergeLocale(base, {
  'locale': 'uz-UZ',
  common: {
    confirm: 'Tasdiqlash',
    cancel: 'Bekor qilish',
    loading: 'Yuklanmoqda',
    close: 'Yopish'
  },
  Calendar: {
    title: 'Sana tanlash',
    confirm: 'Tasdiqlash',
    start: 'boshlanish',
    end: 'tugash',
    today: 'bugun',
    markItems: ['Dush', 'Sesh', 'Chor', 'Pay', 'Jum', 'Shan', 'Yak'],
    yearAndMonth: '${year}/${month}'
  },
  Cascader: {
    placeholder: 'Tanlash'
  },
  Dialog: {
    ok: 'OK'
  },
  DatePicker: {
    tillNow: 'Hozirgacha'
  },
  ErrorBlock: {
    default: {
      title: 'Voy, nimadir noto‘g‘ri ketdi',
      description: 'Iltimos, bir daqiqa kuting va qayta urinib ko‘ring'
    },
    busy: {
      title: 'Voy, yuklanmayapti',
      description: 'Sahifani yangilab ko‘ring'
    },
    disconnected: {
      title: 'Tarmoq band',
      description: 'Sahifani yangilab ko‘ring'
    },
    empty: {
      title: "Voy, buni topa olmadik...",
      description: 'Yangi qidiruvni sinab ko‘rishni xohlaysizmi?'
    }
  },
  Form: {
    required: 'Majburiy',
    optional: 'Ixtiyoriy',
    defaultValidateMessages: {
      default: '${label} uchun maydonni tekshirishda xatolik',
      required: 'Iltimos, ${label} kiriting',
      enum: '${label} quyidagilardan biri bo‘lishi kerak [${enum}]',
      whitespace: '${label} bo‘sh belgi bo‘lishi mumkin emas',
      date: {
        format: '${label} sanasi formati noto‘g‘ri',
        parse: '${label} sanaga aylantirib bo‘lmaydi',
        invalid: '${label} noto‘g‘ri sana'
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: '${label} ${len} ta belgidan iborat bo‘lishi kerak',
        min: '${label} kamida ${min} ta belgidan iborat bo‘lishi kerak',
        max: '${label} ko‘pi bilan ${max} ta belgidan iborat bo‘lishi kerak',
        range: '${label} ${min}-${max} ta belgidan iborat bo‘lishi kerak'
      },
      number: {
        len: '${label} ${len} ga teng bo‘lishi kerak',
        min: '${label} eng kamida ${min} bo‘lishi kerak',
        max: '${label} eng ko‘pi bilan ${max} bo‘lishi kerak',
        range: '${label} ${min}-${max} oralig‘ida bo‘lishi kerak'
      },
      array: {
        len: '${label} ${len} ta bo‘lishi kerak',
        min: '${label} kamida ${min} ta bo‘lishi kerak',
        max: '${label} ko‘pi bilan ${max} ta bo‘lishi kerak',
        range: '${label} miqdori ${min}-${max} oralig‘ida bo‘lishi kerak'
      },
      pattern: {
        mismatch: '${label} ${pattern} andozasiga mos kelmaydi'
      }
    }
  },
  ImageUploader: {
    uploading: 'Yuklanmoqda...',
    upload: 'Yuklash'
  },
  InfiniteScroll: {
    noMore: 'Boshqa maʼlumot yoʻq',
    failedToLoad: 'Yuklab bo‘lmadi',
    retry: 'Qayta urinib ko‘rish'
  },
  Input: {
    clear: 'Tozalash'
  },
  Mask: {
    name: 'Niqob'
  },
  Modal: {
    ok: 'OK'
  },
  PasscodeInput: {
    name: 'Parol kiritish'
  },
  PullToRefresh: {
    pulling: 'Yangilash uchun pastga suring',
    canRelease: 'Darhol yangilash uchun qo‘yib yuboring',
    complete: 'Yangilash muvaffaqiyatli yakunlandi'
  },
  SearchBar: {
    name: 'Qidiruv paneli'
  },
  Slider: {
    name: 'Slayder'
  },
  Stepper: {
    decrease: 'Kamaytirish',
    increase: 'Ko‘paytirish'
  },
  Switch: {
    name: 'O‘zgartirgich'
  },
  Selector: {
    name: 'Tanlov'
  }
});
export default arSA;